import ResponsiveEmbed from "./ResponsiveEmbed"
export default ResponsiveEmbed
